// app/javascript/src/lineage_tree.js
// Renders your tree_json "node" structure into a horizontal SVG tree.
// No D3 needed. Read-only UI.

function textOr(val, fallback = "") {
  return (val === null || val === undefined) ? fallback : String(val);
}

function labelFor(node) {
  const years = [];
  if (node.birth_year) years.push(`b. ${node.birth_year}`);
  if (node.death_year) years.push(`d. ${node.death_year}`);
  const yearsStr = years.length ? ` · ${years.join(" · ")}` : "";
  return `${textOr(node.name, `Person #${node.id}`)}${yearsStr}`;
}

function nodeChildren(node) {
  const kids = [];
//   if (node?.parents?.father?.node) {
//   kids.push({
//     role: "father",
//     relationship_type: node.parents.father.relationship_type,
//     node: node.parents.father.node
//   });
// }

// if (node?.parents?.mother?.node) {
//   kids.push({
//     role: "mother",
//     relationship_type: node.parents.mother.relationship_type,
//     node: node.parents.mother.node
//   });
// }
// if (node?.parents?.father?.node) {
//   kids.push({
//     role: "father",
//     node: {
//       ...node.parents.father.node,
//       relationship_type: node.parents.father.relationship_type
//     }
//   });
// }

// if (node?.parents?.mother?.node) {
//   kids.push({
//     role: "mother",
//     node: {
//       ...node.parents.mother.node,
//       relationship_type: node.parents.mother.relationship_type
//     }
//   });
// }

  if (node?.parents?.father?.node) {
  kids.push({
    role: "father",
    node: node.parents.father.node
  });
}

if (node?.parents?.mother?.node) {
  kids.push({
    role: "mother",
    node: node.parents.mother.node
  });
}
  return kids;
}

// Simple tree layout (horizontal):
// x increases to the right per depth
// y stacks subtrees vertically
function layoutTree(root,

opts) {
  const {
    nodeW = 260,
    nodeH = 56,
    hGap  = 120,
    vGap  = 30
  } = opts;

  // Postorder: compute subtree height
  function computeSubtree(node) {
    const kids = nodeChildren(node);
    if (kids.length === 0) {
      node._subH = nodeH;
      return node._subH;
    }
    let total = 0;
    kids.forEach(({ node: child }) => {
      total += computeSubtree(child);
    });
    total += vGap * (kids.length - 1);
    node._subH = Math.max(nodeH, total);
    return node._subH;
  }

  // Preorder: assign positions
  function assign(node, depth, topY) {
    node._x = depth * (nodeW + hGap);
    // center this node within its subtree box
    node._y = topY + (node._subH - nodeH) / 2;

    const kids = nodeChildren(node);
    let cursorY = topY;
    kids.forEach(({ node: child }) => {
      assign(child, depth + 1, cursorY);
      cursorY += child._subH + vGap;
    });
  }

  computeSubtree(root);
  assign(root, 0, 0);

  // compute overall bounds
  let maxX = 0;
  let maxY = 0;

  (function walk(n) {
    maxX = Math.max(maxX, n._x + nodeW);
    maxY = Math.max(maxY, n._y + nodeH);
    nodeChildren(n).forEach(({ node: c }) => walk(c));
  })(root);

  return { width: maxX, height: maxY, nodeW, nodeH };
}

function buildSVG(container, root, personUrlBase) {
  const opts = { nodeW: 300, nodeH: 60, hGap: 140, vGap: 34 };
  const { width, height, nodeW, nodeH } = layoutTree(root, opts);

  // Create SVG
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("width", Math.ceil(width + 40));
  svg.setAttribute("height", Math.ceil(height + 40));
  svg.setAttribute("viewBox", `-20 -20 ${Math.ceil(width + 40)} ${Math.ceil(height + 40)}`);

  // helpers
  const svgns = "http://www.w3.org/2000/svg";

  function makeEl(name, attrs = {}) {
    const el = document.createElementNS(svgns, name);
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    return el;
  }

  // Draw edges first (under nodes)
  function drawEdges(node) {
    const kids = nodeChildren(node);

    kids.forEach(({ role, node: child }) => {
      const x1 = node._x + nodeW;
      const y1 = node._y + nodeH / 2;
      const x2 = child._x;
      const y2 = child._y + nodeH / 2;

      const midX = (x1 + x2) / 2;

      const path = makeEl("path", {
        d: `M ${x1} ${y1} C ${midX} ${y1}, ${midX} ${y2}, ${x2} ${y2}`,
        fill: "none",
        stroke: role === "father" ? "#198754" : "#0d6efd", // bootstrap-ish
        "stroke-width": "2"
      });
      svg.appendChild(path);

      drawEdges(child);
    });
  }

//   function drawNodes(node) {
//     const group = makeEl("g", { transform: `translate(${node._x}, ${node._y})` });
//       // Click-to-view person
//     e.preventDefault();
//     group.style.cursor = "pointer";
//     group.addEventListener("click", (e) => {
//     e.preventDefault();
//     const url = `${baseUrl}&root_person_id=${encodeURIComponent(node.id)}`;
//     window.open(url, "_blank");
// });
// function drawNodes(node) {
//   const group = makeEl("g", { transform: `translate(${node._x}, ${node._y})` });

//   group.style.cursor = "pointer";
//   group.addEventListener("click", (e) => {
//   e.preventDefault();
//   e.stopPropagation();
//   const url = `${baseUrl}&root_person_id=${encodeURIComponent(node.id)}`;
//   window.open(url, "_blank");
// });

//     // badges
//     const missingFather = !!node?.missing?.father;
//     const missingMother = !!node?.missing?.mother;

//     // Card background
//     const rect = makeEl("rect", {
//       x: "0", y: "0",
//       width: String(nodeW),
//       height: String(nodeH),
//       rx: "10", ry: "10",
//       fill: "#ffffff",
//       stroke: "#ced4da",
//       "stroke-width": "1.5"
//     });
//     group.appendChild(rect);

//     // Name line (truncate visually)
//     const title = makeEl("text", {
//       x: "12",
//       y: "24",
//       "font-size": "14",
//       "font-weight": "600",
//       fill: "#212529"
//     });
//     title.textContent = textOr(node.name, `Person #${node.id}`);
//     group.appendChild(title);
function drawNodes(node) {
  const group = makeEl("g", { transform: `translate(${node._x}, ${node._y})` });

  // Click behavior (keep this)
  group.style.cursor = "pointer";
  group.addEventListener("click", (e) => {
  e.preventDefault();
  e.stopPropagation();
  console.log("[tree click]", node.id, node.display_name || node.name);
});



  // Badge logic (keep this)
  const missingFather = !!node?.missing?.father;
  const missingMother = !!node?.missing?.mother;

  // Card background
  const rect = makeEl("rect", {
    x: "0", y: "0",
    width: String(nodeW),
    height: String(nodeH),
    rx: "10", ry: "10",
    fill: "#ffffff",
    stroke: "#ced4da",
    "stroke-width": "1.5"
  });
  rect.style.pointerEvents = "all";
  group.style.pointerEvents = "all";

  group.appendChild(rect);

    // Name line (truncate visually)
    const title = makeEl("text", {
      x: "12",
      y: "24",
      "font-size": "14",
      "font-weight": "600",
      fill: "#212529"
    });
    const label = node.display_name || `Person #${node.id}`;
    title.textContent = node.relationship_type
      ? `${label} (${node.relationship_type})`
      : label;
        group.appendChild(title);


    // Years line
    const years = makeEl("text", {
      x: "12",
      y: "44",
      "font-size": "12",
      fill: "#6c757d"
    });
    const parts = [];
    if (node.birth_year) parts.push(`b. ${node.birth_year}`);
    if (node.death_year) parts.push(`d. ${node.death_year}`);
    years.textContent = parts.join(" · ");
    group.appendChild(years);

    // Missing badges (right side)
    const badgeX = nodeW - 12;
    let badgeY = 18;

    // function badge(text, bg) {
    //   const t = makeEl("text", {
    //     x: String(badgeX),
    //     y: String(badgeY),
    //     "font-size": "11",
    //     "text-anchor": "end",
    //     fill: bg === "warn" ? "#17a2b8" : "#F99554"
    //   });
    //   t.textContent = text;
    //   group.appendChild(t);
    //   badgeY += 16;
    // }

    // if (missingFather || missingMother) {
    //   if (missingFather) badge("Father missing", "warn");
    //   if (missingMother) badge("Mother missing", "warn");
    // } else {
    //   badge("Parents set", "ok");
    // }

    function badge(text, bg) {
  const t = makeEl("text", {
    x: String(badgeX),
    y: String(badgeY),
    "font-size": "11",
    "text-anchor": "end",
    fill: bg === "warn" ? "#17a2b8" : "#F99554"
  });
  t.textContent = text;
  group.appendChild(t);
  badgeY += 16;
}

// if (node.relationship_type) {
//   badge(`Relationship: ${node.relationship_type}`, "ok");
// }

if (missingFather || missingMother) {
  if (missingFather) badge("Father missing", "warn");
  if (missingMother) badge("Mother missing", "warn");
} else {
  badge("Parents set", "ok");
}

    // Tooltip
    group.appendChild(
      makeEl("title", {})
    ).textContent = labelFor(node);

    svg.appendChild(group);

    nodeChildren(node).forEach(({ node: child }) => drawNodes(child));
    } // <-- CLOSE drawNodes here

    drawEdges(root);
    drawNodes(root);

    container.innerHTML = "";
    container.appendChild(svg);
    }


async function renderLineageTree(container) {
  const lineageId = container.dataset.lineageId;
  const depth = container.dataset.depth || "5";
  const personUrlBase = container.dataset.personUrlBase || "/people";

  const baseUrl = `/lineages/${lineageId}/tree_json?depth=${encodeURIComponent(depth)}`;

  let res;
  try {
    res = await fetch(baseUrl, { headers: { "Accept": "application/json" } });
  } catch (e) {
    container.innerHTML = `<div class="text-danger small">Tree JSON failed to fetch. (Check devtools Network tab)</div>`;
    throw e;
  }

  if (!res.ok) {
    container.innerHTML = `<div class="text-danger small">Tree JSON failed: ${res.status}</div>`;
    return;
  }

  const data = await res.json();

  // Your payload stores the tree at data.node
  const root = data.node;

  if (!root) {
    container.innerHTML = `<div class="text-muted small">No tree data returned.</div>`;
    return;
  }

    buildSVG(container, root, personUrlBase);

    
}

function boot() {
  const el = document.getElementById("lineageTree");
  if (!el) return;
  renderLineageTree(el);
}

document.addEventListener("turbo:load", boot);
document.addEventListener("DOMContentLoaded", boot);
